import { environment } from '../../../environments/environment';

export class UrlHelper {
	/**
	 * Take a URL like https://innova.dev.my.mira-learn.com/abc and replace the subdomain component
	 *
	 * so, for example, if the new subdomain is journey.dev then the new URL wourd be https://journey.dev.mira-learn.com/abc
	 *
	 *
	 * @public
	 * @static
	 * @param {string} newSubdomain
	 * @param {string} url
	 * @returns {string}
	 */
	public static replaceSubdomainInUrl(newSubdomain: string, url: string): string {
		try {
			const urlObj = new URL(url);
			const tld: string = environment.tld;

			if (!urlObj.hostname.endsWith(tld)) {
				throw new Error('URL does not contain expected base domain');
			}

			// Replace everything before mira-learn.com
			const newHostname = newSubdomain
				? `${newSubdomain}.${tld}`
				: tld;

			urlObj.hostname = newHostname;
			return urlObj.toString();

		} catch (error) {
			console.warn('Failed to replace subdomain:', error);
			return url;
		}
	}

	public static queryString(param: string): string | null {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(param);
	}

	public static queryStringCsv(param: string): string[] | null {
		const urlParams = new URLSearchParams(window.location.search);

		const paramAsString: string | null = urlParams.get(param);

		if (!paramAsString) {
			return null;
		}

		return paramAsString.split(',');
	}

	public static ignoreProtocol(url: string): string {
		const reg = new RegExp(/(^\w+:|^)\/\//);
		return url ? url.replace(reg, '//') : url; //ignore the http or https part
	}

	/**
	 * Get all of the sub domains as a string from the current URL.
	 *
	 * So if the url is dev.something.com return 'dev'.
	 *
	 * If the url is dev.my.something.com return 'dev.my'.
	 * @date 2/10/2024 - 10:55:13 AM
	 *
	 * @public
	 * @static
	 * @param {string} [defaultTo='dev']
	 * @returns {*}
	 */
	public static getLeftMostSubDomains(
		defaultTo: string = environment.defaultDevSubDomains
	): string {
		const url: string = window.location.host;

		const parts: string[] = url.split('.');

		if (parts.length < 3 || url.includes('localhost')) {
			return defaultTo;
		}

		parts.pop(); // remove the top level domain .com
		parts.pop(); // remove mira-learn

		return parts.join('.').replace('https://', '').replace('http://', '');
	}

	public static xhr(
		responseType: XMLHttpRequestResponseType,
		method: string,
		url: string,
		contentType?: string
	): XMLHttpRequest {
		const xhr: XMLHttpRequest = new XMLHttpRequest();
		xhr.responseType = responseType;
		xhr.open(method, url);
		//https://stackoverflow.com/questions/22356025/force-cache-control-no-cache-in-chrome-via-xmlhttprequest-on-f5-reload

		if (contentType) {
			xhr.setRequestHeader('Content-Type', contentType);
		}

		xhr.setRequestHeader(
			'cache-control',
			'no-cache, must-revalidate, post-check=0, pre-check=0'
		);
		xhr.setRequestHeader('cache-control', 'max-age=0');
		xhr.setRequestHeader('expires', '0');
		xhr.setRequestHeader('expires', 'Tue, 01 Jan 1980 1:00:00 GMT');
		xhr.setRequestHeader('pragma', 'no-cache');
		return xhr;
	}

	public static saveAs(url: string): void {
		var filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0];
		var xhr = new XMLHttpRequest();
		xhr.responseType = 'blob';
		xhr.onload = function () {
			let a = document.createElement('a');
			a.href = window.URL.createObjectURL(xhr.response);
			a.download = filename;
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
		};
		xhr.open('GET', url);
		xhr.send();
	}
}
